<template>
	<div>
		<nav class="navbar sticky-top navbar-expand-lg mb-3 navbar-dark bg-dark">
		  <a class="navbar-brand" href="/">
		    <img src="/assets/images/logo.png" height="100" class="d-inline-block align-top" alt="">
		  </a>
		  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
		    <span class="navbar-toggler-icon"></span>
		  </button>

		  <div class="collapse navbar-collapse" id="navbarSupportedContent">
		    <ul class="navbar-nav mr-auto">
		      <li class="nav-item active">
		        <a class="nav-link" href="/">Home</a>
		      </li>
		      	<li v-for="(item, key) in menuItems"
		      		class="nav-item" 
		      		:key="key"
		      	>
		        	<a class="nav-link" :href="item.url">{{ item.title }}</a>
		      	</li>
		    </ul>

		    <ul class="navbar-nav ml-auto nav-right">
		    	<li class="nav-item dropdown">
		    	  	<a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
			        	{{ user.firstname }}
			        </a>
			        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
			          <a class="dropdown-item" :href="'/profile/'+user.id">Profiel</a>
			          <a class="dropdown-item" href="#" @click="logout()">Uitloggen</a>
			        </div>
		    	</li>
		    </ul>
		  </div>
		</nav>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {

	name: 'nav-header',
  	data () {
	    return {
	    	user: this.$store.state.user,
	    	menu:[
	    		{
	    			url		: '/branches',
	    			title	: 'Vestigingen',
	    		},

	    		{
	    			url		: '/users',
	    			title	: 'Medewerkers',
	    			permission  	: 'read users',
	    		},

	    		{
	    			url		: '/branch/1',
	    			title	: 'Management / Hoofdkantoor',
	    			permission  	: 'show management',
	    		},

	    		// {
	    		// 	url		: '/machines',
	    		// 	title	: 'Automaten',
	    		// },

	    		// {
	    		// 	url		: '/messages/type/2',
	    		// 	title	: 'Storingen',
	    		// },

	    		{
	    			url		: '/settings',
	    			title	: 'Instellingen',
	    			permission  	: 'show settings',
	    		},

	    	]
	    }
  	},
  	computed:{
  		menuItems(){
  			let items = [];
  			let user = this.user;
  			let thas = this;
  			this.menu.forEach(function(item) {
  				let add = true;

  				if(thas.hasProp(item, 'role')){
  					console.log(item);
  					if(!thas.checkUserHasRole(item.role)){
  						add = false;
  					}
  				}else if(thas.hasProp(item, 'permission')){
  					if(!thas.checkUserHasPermission(item.permission)){
  						add = false;
  					}
  				}

  				if(add){
  					items.push(item);
  				}
  			});
  			return items;
  		}
  	},
  	methods:{
	  	logout(){
	        this.$store.commit('logout');
	        window.location='/login';
	    },
  	}
}
</script>

<style lang="css" scoped>
	.bg-black{
		background-color: #000;
	}
</style>